export const PLACEHOLDER = '-';
export const ITEMS_PER_PAGE = 10;
